module.exports = __webpack_public_path__ + "static/img/2.016349c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/21/eng/2.png
// module id = uTLM
// module chunks = 0